var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-field",
              { attrs: { grouped: "" } },
              [
                _vm.user.group.plants && _vm.user.group.plants.length != 0
                  ? _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: { icon: "industry", expanded: "" },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          },
                          _vm._l(_vm.user.group.plants, function (plant) {
                            return _c(
                              "option",
                              { key: plant.id, domProps: { value: plant } },
                              [_vm._v(" " + _vm._s(plant.name) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  : _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c("multiselect", {
                          staticStyle: { "min-width": "400px" },
                          attrs: {
                            options: _vm.plants,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick plant",
                            "custom-label": (obj) => obj.id + " - " + obj.name,
                            "track-by": "name",
                          },
                          model: {
                            value: _vm.selectedPlant,
                            callback: function ($$v) {
                              _vm.selectedPlant = $$v
                            },
                            expression: "selectedPlant",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
            _c(
              "b-field",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "left-right",
                    attrs: {
                      type: "is-warning",
                      "icon-left": "arrows-rotate",
                      disabled: _vm.isLoading || _vm.selectedPlant === null,
                    },
                    on: {
                      click: () => {
                        _vm.resetData()
                        _vm.getData()
                      },
                    },
                  },
                  [_vm._v(" Load ")]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Hourly productivity targets", grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Manual washing target" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.hourly_washing,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "hourly_washing", $$v)
                        },
                        expression: "bonus.hourly_washing",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Machine washing target" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.hourly_machinewash,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "hourly_machinewash", $$v)
                        },
                        expression: "bonus.hourly_machinewash",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Crate repair target" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.hourly_repair,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "hourly_repair", $$v)
                        },
                        expression: "bonus.hourly_repair",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Door repair target" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.hourly_repair_door,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "hourly_repair_door", $$v)
                        },
                        expression: "bonus.hourly_repair_door",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Minimum Production Percentage" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.under_production_target,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "under_production_target", $$v)
                        },
                        expression: "bonus.under_production_target",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Forklift target" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.forklift_target,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "forklift_target", $$v)
                        },
                        expression: "bonus.forklift_target",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Bonus amounts", grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Attendance bonus" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.attendance_amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "attendance_amount", $$v)
                        },
                        expression: "bonus.attendance_amount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Production + Quality bonus" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.all_targets_amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "all_targets_amount", $$v)
                        },
                        expression: "bonus.all_targets_amount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Production - Quality bonus" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.prod_target_amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "prod_target_amount", $$v)
                        },
                        expression: "bonus.prod_target_amount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Minimum + Quality bonus" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.nc_target_amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "nc_target_amount", $$v)
                        },
                        expression: "bonus.nc_target_amount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Minimum - Quality bonus" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.under_production_amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "under_production_amount", $$v)
                        },
                        expression: "bonus.under_production_amount",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Other targets", grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Quality control frequency target" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.bonus.control_frequency_target,
                        callback: function ($$v) {
                          _vm.$set(_vm.bonus, "control_frequency_target", $$v)
                        },
                        expression: "bonus.control_frequency_target",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-success",
                  "icon-left": "save",
                  disabled: _vm.isLoading || !_vm.isLoaded,
                },
                on: {
                  click: () => {
                    _vm.saveBonus()
                  },
                },
              },
              [_vm._v(" Save ")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }